import { ListTable } from '@nv/components'
import styles from './AdminCommunications.module.scss'

export const AdminCommunications = () => {
  return (
    <div className={styles['container']}>
      <ListTable />
    </div>
  )
}
